(() => {
  const initProductDetailNav = () => {
    const productInfo = document.querySelector('product-info');
    const tabsShell = productInfo?.querySelector('.tf-pdp-tabs-shell');
    const tabs = tabsShell?.querySelectorAll('a[href^="#"]');

    if (!productInfo || !tabsShell || !tabs?.length) return;

    const header = document.querySelector('.section-header');

    const getHeaderOffset = () => {
      if (!header || header.classList.contains('shopify-section-header-hidden')) return 0;

      const rect = header.getBoundingClientRect();
      return Math.max(0, Math.round(rect.bottom));
    };

    const isTabsSticky = () => getComputedStyle(tabsShell).position === 'sticky';
    const getTabsOffset = () => (isTabsSticky() ? Math.round(tabsShell.getBoundingClientRect().height || 0) : 0);

    const setHeaderOffset = () => {
      productInfo.style.setProperty('--tf-sticky-tabs-top', `${getHeaderOffset()}px`);
    };

    const findTargetById = (id) => {
      const rawId = id.replace('#', '');
      let target = document.getElementById(rawId);

      if (!target && rawId.startsWith('shopify-section-')) {
        const sectionKey = rawId.replace('shopify-section-', '');
        target = document.querySelector(`[id$="__${sectionKey}"], [id*="${sectionKey}"]`);
      }

      if (!target && rawId.includes('1778790551aa2431d7')) {
        const reviewHeading = Array.from(document.querySelectorAll('h2, [role="heading"]')).find((heading) =>
          /customers are saying|recenzie|reviews/i.test(heading.textContent || '')
        );

        target = reviewHeading?.closest('.shopify-section, section') || reviewHeading;
      }

      return target;
    };

    const getTarget = (link) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return null;
      return findTargetById(id);
    };

    const getTabEntries = () =>
      Array.from(tabs)
        .map((link) => ({ link, target: getTarget(link) }))
        .filter((entry) => entry.target);

    const setActive = (activeLink) => {
      tabs.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const syncActiveTab = () => {
      const tabEntries = getTabEntries();
      if (!tabEntries.length) return;

      const viewportMarker = Math.min(window.innerHeight * 0.5, 420);
      const marker = window.scrollY + getHeaderOffset() + getTabsOffset() + viewportMarker;
      let activeEntry = tabEntries[0];

      tabEntries.forEach((entry) => {
        const top = entry.target.getBoundingClientRect().top + window.scrollY;
        if (top <= marker) activeEntry = entry;
      });

      setActive(activeEntry.link);
    };

    const sync = () => {
      setHeaderOffset();
      syncActiveTab();
    };

    const requestSync = () => {
      if (requestSync.frame) return;
      requestSync.frame = window.requestAnimationFrame(() => {
        requestSync.frame = null;
        sync();
      });
    };

    tabs.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = getTarget(link);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - getTabsOffset() - 18;
        window.history.pushState(null, '', link.getAttribute('href'));
        window.scrollTo({ top, behavior: 'smooth' });
        setActive(link);
      });
    });

    productInfo.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.closest('.tf-pdp-tabs')) return;

      link.addEventListener('click', (event) => {
        const target = getTarget(link);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - getTabsOffset() - 18;
        window.history.pushState(null, '', link.getAttribute('href'));
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    document.addEventListener('shopify:section:load', requestSync);

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetailNav);
  } else {
    initProductDetailNav();
  }
})();
